import Vue from "vue";

export function lengthToMinutes(length) {
  if (!length || typeof length !== "number") {
    return "0:00";
  }

  length = parseInt(length);

  let minutes = Math.floor(length / 60);
  let seconds = length % 60;

  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return minutes + ":" + seconds;
}

Vue.filter("lengthToMinutes", lengthToMinutes);

export default lengthToMinutes;
